export const GET_QUESTION_TYPES = 'Get_Question_Types';